// extracted by mini-css-extract-plugin
export default {"wrap":"kI-z","fullWidth":"lI-z","hideOnDesktop":"mI-z","content":"nI-z","hasOpenedNav":"oI-z","crumbsList":"pI-z","dropdownsWrap":"qI-z"};